import React, { useState, useEffect, useRef } from "react";
import "./Reviews.css";
import { FaStar, FaStarHalfAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import abc from "../assets/images/abc.png";
import abc1 from "../assets/images/abc1.png";
import abc2 from "../assets/images/abc2.png";
import abc3 from "../assets/images/abc3.png";
import abc4 from "../assets/images/abc4.png";
import abc5 from "../assets/images/abc5.png";
import abc6 from "../assets/images/abc6.png";
import abc7 from "../assets/images/abc7.png";
import abc8 from "../assets/images/abc8.png";
import abc9 from "../assets/images/abc9.png";
import abc1m from "../assets/images/abc1m.png";
import abc2m from "../assets/images/abc2m.png";
import abc3m from "../assets/images/abc3m.png";
import abc4m from "../assets/images/abc4m.png";
import abc5m from "../assets/images/abc5m.png";
import abc6m from "../assets/images/abc6m.png";
import abc7m from "../assets/images/abc7m.png";
import abc8m from "../assets/images/abc8m.png";
import abc9m from "../assets/images/abc9m.png";
import abc10m from "../assets/images/abc10m.png";

function Reviews({
  variant = "full",
  showSidebarTitle = true,
  showWaves = true,
  showBackground = true,
  showButton = true,
}) {
  const reviews = [
    { id: 1,
     text: "I walked in feeling a bit nervous.Within minutes, it felt comfortable.People were warm and easy to talk to.The vibe was genuinely nice",
      name: "Shalini Sharma", time: "1 week ago", location: "Chandigarh, India",
       rating: 4.5,
        avatar: abc
       },
       
    { id: 2, text: "It didn’t feel like a typical dating event.No pressure, no awkwardness. Just good conversations and good energy.That made all the difference.", name: "Priya Sharma", time: "2 weeks ago", location: "Chandigarh, India", rating: 5, avatar: abc1 },
    { id: 3, text: "The crowd felt respectful and real.Everyone was there to interact.Conversations flowed naturally.Nothing felt forced", name: "Rahul Mehta", time: "5 days ago", location: "Mohali, India", rating: 4.3, avatar: abc1m },
    { id: 4, text: "I wasn’t sure what to expect.But the format worked really well.The games helped break the ice.After that, it was easy", name: "Sneha Patel", time: "2 weeks ago", location: "jaipur, India", rating: 5, avatar: abc2 },
    { id: 5, text: "The event was very well managed.Hosts were friendly and attentive.Everything moved smoothly.You could just relax and enjoy.", name: "Arjun Kumar", time: "2 weeks ago", location: "Ludhiana, India", rating: 4, avatar: abc2m },
    { id: 6, text: "I usually avoid social mixers.This one felt different.It was calm, fun, and welcoming.I’d come again.", name: "Anjali Singh", time: "1 week ago", location: "Chandigarh, India", rating: 4.5, avatar: abc3 },
    { id: 7, text: "Face-to-face conversations felt refreshing.Much better than apps.People were present and engaged.That felt nice", name: "Vikram Desai", time: "1 weeks ago", location: "Mohali, India", rating: 5, avatar: abc3m },
    { id: 8, text: "I came alone to challenge myself.Ended up having great conversations.Never felt out of place.That’s rare for me.", name: "Neha Gupta", time: "2 weeks ago", location: "Jaipur, India", rating: 4.5, avatar: abc4 },
    { id: 9, text: "The balance of people was good.No overcrowding or chaos.Plenty of time to talk.Very comfortable experience.", name: "Rohan Verma", time: "3 days ago", location: "Ludhiana, India", rating: 4, avatar: abc4m },
    { id: 10, text: "The energy stayed positive throughout.No dull moments.Time passed quickly.That says a lot.", name: "Kavita Joshi", time: "1 week ago", location: "Chandigarh, India", rating: 5, avatar: abc5 },
    { id: 11, text: "It felt safe and thoughtfully planned.Especially for first-timers.I could be myself.That mattered most.", name: "Amitabh Rao", time: "2 weeks ago", location: "Mohali, India", rating: 4.3, avatar: abc5m },
    { id: 12, text: "The crowd quality was impressive.Everyone was respectful.Good conversations all around.Very pleasant evening.", name: "Pooja Nair", time: "5 days ago", location: "Jaipur, India", rating: 4.8, avatar: abc6 },
    { id: 13, text: "I liked how natural everything felt.No loud pressure or pushing.Just conversations at your pace.That was refreshing.", name: "Sanjay Malhotra", time: "1 week ago", location: "Ludhiana, India", rating: 4.5, avatar: abc6m },
    { id: 14, text: "The icebreakers actually worked.Not cringe at all.Helped everyone open up.Good approach.", name: "Ritika Bhatia", time: "2 weeks ago", location: "Chandigarh, India", rating: 5, avatar: abc7 },
    { id: 15, text: "I didn’t expect to enjoy it this much.But I genuinely did.It felt effortless.Would recommend it.", name: "Manish Tiwari", time: "3 days ago", location: "Mohali, India", rating: 4, avatar: abc7m },
    { id: 16, text: "Chandigarh really needed something like this.A space to connect casually.Without awkwardness.Mulaqaat delivered.", name: "Divya Saxena", time: "1 week ago", location: "Jaipur, India", rating: 4.7, avatar: abc8 },
    { id: 17, text: "The hosts set the tone perfectly.Friendly and calm.It helped everyone relax.Great execution.", name: "Karan Singh", time: "2 weeks ago", location: "Ludhiana, India", rating: 5, avatar: abc8m },
    { id: 18, text: "I appreciated the focus on genuine interaction.No distractions or gimmicks.Just real conversations.That’s what I wanted.", name: "Simran Kaur", time: "5 days ago", location: "Chandigarh, India", rating: 4.5, avatar: abc9 },
    { id: 19, text: "As an introvert, I felt included.No pressure to perform.Conversations happened naturally.That felt goo", name: "Aakash Chopra", time: "1 week ago", location: "Mohali, India", rating: 4, avatar: abc9m },
    { id: 20, text: "I left feeling happy and light.Good conversations stayed with me.It was worth coming.Looking forward to the next one.", name: "Nitin Saini", time: "2 weeks ago", location: "Jaipur, India", rating: 4.8, avatar: abc10m },
  ];

  // 1. Double the array for seamless infinite scrolling
  const displayReviews = [...reviews, ...reviews];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);
  const [cardStep, setCardStep] = useState(316);
  const [isTransitioning, setIsTransitioning] = useState(true); // New: to control seamless jump
  const cardsRowRef = useRef(null);
  const isCarouselOnly = variant === "carousel";

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    for (let i = 0; i < fullStars; i++) stars.push(<FaStar key={i} className="star-icon" />);
    if (hasHalfStar) stars.push(<FaStarHalfAlt key="half" className="star-icon" />);
    return stars;
  };

  const nextSlide = () => {
    if (currentIndex >= reviews.length) return; // Wait for the reset logic
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev + 1);
  };

  const prevSlide = () => {
    if (currentIndex <= 0) {
      // Jump to end of first set without animation, then slide back
      setIsTransitioning(false);
      setCurrentIndex(reviews.length);
      setTimeout(() => {
        setIsTransitioning(true);
        setCurrentIndex(reviews.length - 1);
      }, 20);
    } else {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  // 2. Seamless Loop Logic: When we reach the clone, jump back to index 0 silently
  useEffect(() => {
    if (currentIndex === reviews.length) {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(0);
      }, 600); // 600ms matches the CSS transition time
      return () => clearTimeout(timer);
    }
  }, [currentIndex, reviews.length]);

  // Auto Scroll
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  useEffect(() => {
    const updateLayout = () => {
      const isMobile = window.innerWidth <= 768;
      setCardsToShow(isMobile ? 1 : 3);
      if (!cardsRowRef.current) return;
      const card = cardsRowRef.current.querySelector(".review-card");
      if (!card) return;
      const cardWidth = card.getBoundingClientRect().width;
      const styles = window.getComputedStyle(cardsRowRef.current);
      const gapValue = parseFloat(styles.columnGap || styles.gap || "0");
      setCardStep(cardWidth + (Number.isNaN(gapValue) ? 0 : gapValue));
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  const cards = (
    <div className="reviews-cards-wrapper">
      <div
        className="reviews-cards"
        ref={cardsRowRef}
        style={{
          transform: `translateX(-${currentIndex * cardStep}px)`,
          transition: isTransitioning ? "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)" : "none"
        }}
      >
        {displayReviews.map((review, index) => (
          <div key={`${review.id}-${index}`} className="review-card">
            <p className="review-text">{review.text}</p>
            <div className="review-rating">{renderStars(review.rating)}</div>
            <div className="review-author">
              <div className="author-avatarr">
                <img src={review.avatar} alt={review.name} />
              </div>
              <div className="author-info">
                <div className="author-name">{review.name}</div>
                <div className="author-meta">{review.time}</div>
                <div className="author-meta">{review.location}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // Remaining JSX (Header, Sidebar, Waves) remains exactly as you provided...
  if (isCarouselOnly) {
    return (
      <section className="reviews-section reviews-section--carousel">
        <div className="reviews-container">{cards}</div>
      </section>
    );
  }

  return (
    <section className={`reviews-section${showBackground ? "" : " reviews-section--no-bg"}`}>
      <div className="reviews-container">
        {showWaves && (
          <div className="waves-bg" aria-hidden="true">
            <svg className="wave-line wave-1" viewBox="0 0 1920 300" preserveAspectRatio="none"><path opacity="0.35" d="M1.47526e-07 62.7753C0.356904 63.7094 0.713804 64.6435 1.07071 65.5777C33.3174 53.2994 62.7527 43.5385 95.7874 34.3912C322.067 -33.0995 568.313 13.9892 775.767 120.584C1095.1 277.823 1396.86 539.616 1772.83 509.431C1806.54 507.027 1838.38 502.812 1871.87 496.416C1871.68 495.434 1871.49 494.452 1871.31 493.47C1837.93 499.844 1806.21 504.043 1772.62 506.439C1398.19 536.599 1096.94 275.501 777.087 117.89C569.348 11.1063 321.974 -36.2403 94.9904 31.4991C61.8536 40.6746 32.3333 50.4641 1.47526e-07 62.7753Z" fill="#F69575" /></svg>
            <svg className="wave-line wave-2" viewBox="0 0 1920 300" preserveAspectRatio="none"><path opacity="0.35" d="M-0.472413 154.958C0.0849717 155.788 0.642357 156.618 1.19974 157.449C29.8697 138.249 56.3646 122.132 86.5049 105.807C291.874 -10.731 542.407 -20.0899 768.488 37.2439C1114.96 118.829 1467.76 306.247 1827.37 192.479C1859.69 182.572 1889.77 171.323 1920.97 157.575C1920.57 156.661 1920.16 155.746 1919.76 154.831C1888.66 168.531 1858.69 179.74 1826.5 189.61C1468.38 303.008 1116.23 116.153 769.169 34.3223C542.769 -23.1314 291.078 -13.7707 85.0793 103.167C54.8459 119.543 28.2745 135.706 -0.472413 154.958Z" fill="#F69575" /></svg>
            <svg className="wave-line wave-3" viewBox="0 0 1920 300" preserveAspectRatio="none"><path opacity="0.35" d="M1913.11 2.32339C1912.48 1.54892 1911.84 0.774443 1911.21 -2.21491e-05C1884.46 21.7977 1859.59 40.3216 1831.11 59.3952C1637.54 194.633 1388.99 227.387 1158.53 191.453C805.949 142.635 437.167 -10.9583 89.7697 135.951C58.5229 148.837 29.6296 162.851 -0.151297 179.457C0.336439 180.33 0.824054 181.203 1.31179 182.076C30.9906 165.527 59.7798 151.564 90.9113 138.725C436.851 -7.67514 804.93 145.42 1158.13 194.425C1388.91 230.449 1638.62 197.585 1832.78 61.8899C1861.35 42.7574 1886.29 24.1796 1913.11 2.32339Z" fill="#F69575" /></svg>
            <svg className="wave-line wave-4" viewBox="0 0 1920 300" preserveAspectRatio="none"><path opacity="0.35" d="M-0.472413 154.958C0.0849717 155.788 0.642357 156.618 1.19974 157.449C29.8697 138.249 56.3646 122.132 86.5049 105.807C291.874 -10.731 542.407 -20.0899 768.488 37.2439C1114.96 118.829 1467.76 306.247 1827.37 192.479C1859.69 182.572 1889.77 171.323 1920.97 157.575C1920.57 156.661 1920.16 155.746 1919.76 154.831C1888.66 168.531 1858.69 179.74 1826.5 189.61C1468.38 303.008 1116.23 116.153 769.169 34.3223C542.769 -23.1314 291.078 -13.7707 85.0793 103.167C54.8459 119.543 28.2745 135.706 -0.472413 154.958Z" fill="#F69575" /></svg>
          </div>
        )}

        <div className="reviews-header">
          <div className="reviews-title">Read Reviews,<br /><span>From Our Community</span></div>
        </div>

        <div className="reviews-content">
          <div className="reviews-sidebar">
            <div className="big-quote">
              <svg width="100" height="71" viewBox="0 0 100 71" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 26.625C0 11.9147 11.9866 0 26.7857 0H28.5714C32.5223 0 35.7143 3.17281 35.7143 7.1C35.7143 11.0272 32.5223 14.2 28.5714 14.2H26.7857C19.8884 14.2 14.2857 19.7691 14.2857 26.625V28.4H28.5714C36.4509 28.4 42.8571 34.7678 42.8571 42.6V56.8C42.8571 64.6322 36.4509 71 28.5714 71H14.2857C6.40625 71 0 64.6322 0 56.8V49.7V42.6V26.625ZM57.1429 26.625C57.1429 11.9147 69.1295 0 83.9286 0H85.7143C89.6652 0 92.8571 3.17281 92.8571 7.1C92.8571 11.0272 89.6652 14.2 85.7143 14.2H83.9286C77.0312 14.2 71.4286 19.7691 71.4286 26.625V28.4H85.7143C93.5938 28.4 100 34.7678 100 42.6V56.8C100 64.6322 93.5938 71 85.7143 71H71.4286C63.5491 71 57.1429 64.6322 57.1429 56.8V49.7V42.6V26.625Z" fill="#D9D9D9" /></svg>
            </div>
            {showSidebarTitle && <div className="sidebar-title">What our<br />customers are<br />saying</div>}
            <div className="nav-row">
              <button className="nav-btn" onClick={prevSlide}><FaChevronLeft /></button>
              <div className="nav-line">
                <span className="nav-progress" style={{ width: `${((currentIndex % reviews.length + 1) / reviews.length) * 100}%` }} />
              </div>
              <button className="nav-btn" onClick={nextSlide}><FaChevronRight /></button>
            </div>
          </div>
          {cards}
        </div>
        {showButton && <a href="/events" className="join-btn">Join the next Mulaqaat</a>}
      </div>
    </section>
  );
}

export default Reviews;